<template>
  <div class="scheduleManagement maxWidth">
    <!-- 面包屑-start -->
    <div class="breadTop">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">
          <i class="el-icon-s-home"></i>
          <strong>首页</strong>
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <strong>日程管理</strong>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <!-- 面包屑-end -->

    <div class="flex wz-color-white" style="margin-top: 15px">
    <!-- 左侧日历部分 -->
    <div class="flxL">
      <DateManage title="日程管理" :time="time" @update="callBack"></DateManage>
    </div>
    <!-- 右侧部分 -->
    <div class="flxR flex-1 overflow-h wz-color-white">
      <Content :passtype="type"></Content>
    </div>
  </div>
  </div>
</template>

<script>
import DateManage from "./date.vue";
import Content from "./content.vue";

export default {
  provide() {
    return {
      passTime: () => this.time,
      callBack: this.callBack,
    };
  },
  data() {
    return {
      time: new Date(),
      type: {},
    };
  },
  components: {
    DateManage,
    Content,
  },
  methods: {
    // 提供给子级调用
    callBack(e) {
      this.time = e;
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      const type = +from.query.type;
      const time = +from.query.time;
      console.log("查看", type);
      if (from.path == "/plan/add" || from.path == "/plan/detail") {
        if (type) {
          vm.type = {
            type,
            time
          };
        }
      }
    });
  },
};
</script>
<style lang='less' scoped>
.scheduleManagement {
  min-height: 100%;
  padding: 15px;
  padding-top: 0;
  box-sizing: border-box;
}
</style>